import { definitions } from "api";
import useRecords from "./useRecords";

type ReferralSource = definitions["referral_source"];

const useReferralSources = () => useRecords<ReferralSource>("referral-sources");

export default useReferralSources;
